import { Spin } from 'antd';
import { FC, useEffect, useState } from 'react';
import cn from 'classnames';

import s from './index.module.scss';

interface ImageLoaderProps {
	photo: string;
	wrapperClassName: string;
}

export const ImageLoader: FC<ImageLoaderProps> = ({ photo, wrapperClassName }) => {
	const [loading, setLoading] = useState(true);

	const [src, setSrc] = useState('');

	useEffect(() => {
		const uniqueSrc = `${photo}?t=${new Date().getTime()}`;
		setSrc(uniqueSrc);
	}, [photo]);

	return (
		<div className={cn(wrapperClassName, s.root)}>
			{loading && (
				<div className={s.spinner}>
					<Spin size="large" />
				</div>
			)}

			<img
				onLoad={() => {
					setLoading(false);
				}}
				src={src}
				alt={''}
				loading="eager"
				onError={({ currentTarget }) => {
					currentTarget.onerror = null;
				}}
			/>
		</div>
	);
};
